( function () {
	'use strict';

	// auto select when field is clicked
	function ngEnter () {
		function link ( scope, element, attrs ) {
			element.bind( 'keydown keypress', function ( event ) {
				if ( event.which === 13 ) {
					scope.$apply( function () {
						scope.$eval( attrs.ngEnter );
					} );

					event.preventDefault();
				}
			} );
		}

		return {
			'restrict' : 'A',
			'link'     : link
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'ngEnter', ngEnter );
} )( );
